import { Node } from '../types'

export default function getValueFromNodes(nodes: Node[], property: string) {
  return nodes?.find(node => node.name === property)?.value
}
